import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Collection } from '@morningtrain/react-resources'
import EconomyChecklistProgress from 'widgets/economy/partials/EconomyChecklistProgress'
import { StaticFilter } from '@morningtrain/react-filters'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import AllChecklistsSmartview from 'widgets/economy/smartviews/AllChecklistsSmartview'
import * as Columns from 'support/columns'
import { Table } from 'widgets/crud'
import CookieFilter from "support/filters/CookieFilter";

export default function RestaurantChecklistsEconomyWidget () {
  return (
    <Widget>
      <Translator namespace='economy.checklists'>
        <UI.Card paddingBottom={false} tight className='pt-3' overflow='hidden'>
          <UI.CardHeader withPadding withMargin={false}>
            <UI.Text weight='medium' size='lg'>
              <Translation name='title' />
            </UI.Text>
            <UI.ButtonWrap>
              <MountSmartviewOnClick smartview={<AllChecklistsSmartview />} replace={false}>
                <UI.Button color='lightgray'>
                  <Translation name='generic.viewall' />
                </UI.Button>
              </MountSmartviewOnClick>
            </UI.ButtonWrap>
          </UI.CardHeader>
          <div className='w-full flex-grow' />
          <Collection resourceName='economy' operationName='checklists'>
            <CookieFilter name='period' cookieKey='page.filters.period' />
            <StaticFilter name='limit' value={6} />

            <div className='flex mt-5 flex-grow flex-col'>
              <Table striped headless>
                <Columns.Text name='name' label='' />
                <Columns.Column className='w-28 p-0' alignment='right' label=''>
                  <EconomyChecklistProgress />
                </Columns.Column>
                <Columns.Percentage className='w-10 font-medium' alignment='right' name='checklist_progress' label='' decimals={0} />
              </Table>
            </div>

          </Collection>
        </UI.Card>
      </Translator>
    </Widget>
  )
}
